import React, { Fragment, useEffect, useState } from 'react'
import { AddButton, Search } from '../../components'
import Card from './card'
import Detail from './detail'

import axios from 'axios'
import AddGroup from './modals/AddGroup'
import Confirm from './modals/Confirm'
import { connect } from 'react-redux'
import Everyone from './everyone'
import produce from 'immer'
import { useQuery } from 'react-query'

const useGroups = () => {
  const { data: initialGroups, isLoading: isLoadingGroups, refetch } = useQuery(
    'groups', async () => {
      const { data } = await axios.get('/api/groups')
      return data
    })

  const {
    data: initialPermissionsOfEveryone,
    isLoading: isLoadingEveryone,
    refetch: refetchEveryone,
  } = useQuery('everyone', async () => {
    const { data } = await axios.get('api/groups/everyone')
    return data
  })

  const [groups, setGroups] = useState([])
  const [permissionsOfEveryone, setEveryone] = useState([])

  useEffect(() => {
    if (initialGroups) {
      setGroups(initialGroups)
    }
  }, [initialGroups, isLoadingGroups])
  useEffect(() => {
    if (initialPermissionsOfEveryone) {
      setEveryone(initialPermissionsOfEveryone)
    }
  }, [initialPermissionsOfEveryone])

  const getGroup = (_id) => groups.find(group => group._id === _id)

  const addGroup = async (group) => {
    const { data } = await axios.post('/api/groups', group)
    setGroups(produce(groups, draft => {
      draft.push(data)
    }))
    return group
  }

  const updateGroup = (_id, obj) => {
    setGroups(produce(groups, draft => {
      const index = draft.findIndex(_g => _g._id === _id)
      if (index !== -1) {
        draft[index] = { ...draft[index], ...obj }
      }
    }))
  }

  const reloadGroup = async () => {
    const { data } = await refetch()
    setGroups(data)
  }

  const saveGroups = async (_id) => {
    try {
      if (_id === 'everyone') {
        await axios.put('/api/groups/everyone', { permissionsOfEveryone })
      } else {

        const group = groups.find(_g => _g._id === _id)
        if (group) {
          await axios.post('/api/groups/' + _id, group)
        }
      }
      return true
    } catch (e) {
      console.log(e)
    }
  }

  const removeGroup = async (_id) => {
    await axios.delete('/api/groups/' + _id)
    await refetch()
  }

  const reloadEveryone = async () => {
    const { data } = await refetchEveryone()
    setEveryone(data)
  }

  return [
    groups,
    isLoadingGroups && isLoadingEveryone,
    getGroup,
    addGroup,
    updateGroup,
    reloadGroup,
    saveGroups,
    permissionsOfEveryone,
    setEveryone,
    removeGroup,
    reloadEveryone]
}

const useUsers = (initial = []) => {
  const [users, setUsers] = useState(initial)

  const requestUsers = async () => {
    const { data } = await axios.get('/api/users')
    setUsers(data)
  }

  useEffect(() => {
    requestUsers()
  }, [])
  return [users]
}

const Groups = ({ collections }) => {
  const [active, setActive] = useState('everyone')
  const [search, setSearch] = useState('')
  const [isModal, setModal] = useState(false)
  const [confirm, setConfirm] = useState(null)
  const [isActiveSave, setActiveSave] = useState(false)
  const [
    groups,
    isLoading,
    getGroup,
    addGroup,
    updateGroup,
    reloadGroup,
    saveGroups,
    permissionsOfEveryone,
    setEveryone,
    removeGroup,
    reloadEveryone] = useGroups(
    [], search)
  const [users] = useUsers([])
  const openModal = () => {
    setModal(true)
  }

  const onOk = async (name) => {
    const g = await addGroup({ name, users: [], permissions: [] })
    setActive(g._id)
    onCancel()
  }

  const onCancel = () => {
    setModal(false)
  }

  const ConfirmOk = async () => {
    if (await saveGroups(active)) {
      setActiveSave(false)
      setActive(confirm)
      setConfirm(null)
    }
  }

  const ConfirmLeave = () => {
    reloadGroup()
    setActive(confirm)
    setActiveSave(false)
    setConfirm(null)
  }

  const ConfirmCancel = () => {
    setConfirm(null)
  }
  const onRemove = _id => {
    removeGroup(_id)
  }

  return (<Fragment>
    <div className="row">
      {isLoading &&
        (<div className="col-2 vh-75 overflow-auto">Loading...</div>)}
      {!isLoading && (<div className="col-2 vh-75 overflow-auto">
        <label className="mb-2">GROUPS</label>
        <Search onSubmit={(_s) => {
          setSearch(_s)
          setActive('everyone')
        }}/>
        <div style={{ height: '78vh', overflow: 'auto' }}>
          <Card name={'Everyone'}
                setActive={(val) => {
                  if (isActiveSave) {
                    setConfirm('everyone')
                  } else {
                    setActive('everyone')
                  }
                }}
                index={'everyone'}
                isActive={'everyone' === active}
                isRemove={false}
          />
          {groups.filter(group => !search ||
            group.name.toUpperCase().includes(search.toUpperCase())).
            map((group, index) => <Card
              key={group._id}
              support={group.support}
              name={group.name}
              setActive={() => {
                if (isActiveSave) {
                  setConfirm(group._id)
                } else {
                  setActive(group._id)
                }
              }}
              isActive={group._id === active}
              index={index}
              isRemove={!group.support}
              remove={() => onRemove(group._id)}
            />)}
        </div>
        <div className={'my-2'}>
          <AddButton id={'addUsers'} label={'Add New Group'}
                     onClick={openModal}/>
        </div>
      </div>)}
      {!isLoading && active === 'everyone' &&
        <Everyone users={users.filter(u => !u.isExternal)}
                  reload={() => {
                    setActiveSave(false)
                    reloadEveryone()
                  }}
                  permissions={permissionsOfEveryone}
                  isActiveSave={isActiveSave}
                  save={async () => {
                    if (await saveGroups('everyone')) {
                      setActiveSave(false)
                    }
                  }}
                  update={values => {
                    setActiveSave(true)
                    setEveryone(values)
                  }}
                  collections={collections}/>}
      {getGroup(active) && <Fragment>
        <Detail
          item={getGroup(active)}
          isActiveSave={isActiveSave}
          update={nextObj => {
            updateGroup(active, nextObj)
            setActiveSave(true)
          }}
          users={users.filter(u => !u.isExternal)}
          save={async () => {
            if (await saveGroups(active)) {
              setActiveSave(false)
            }
          }}
          reload={() => {
            reloadGroup()
            setActiveSave(false)
          }}
          collections={collections}
        />
      </Fragment>}
    </div>
    <AddGroup active={isModal} onCancel={onCancel} onOk={onOk}/>
    <Confirm active={!!confirm} ok={ConfirmOk} leave={ConfirmLeave}
             cancel={ConfirmCancel}/>
  </Fragment>)
}
const mapStateToProps = state => {
  const { collections } = state
  return { collections }
}
export default connect(mapStateToProps)(Groups)
